import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var ICSCalendarBuilder = /*#__PURE__*/function () {
  function ICSCalendarBuilder() {
    _classCallCheck(this, ICSCalendarBuilder);
  }

  _createClass(ICSCalendarBuilder, null, [{
    key: "BuildICSHrefString",
    value: function BuildICSHrefString(eventTitle, eventDescription, eventLocation, eventStartDate, eventEndDate) {
      var isAllDayEvent = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var icsLink = this.GetICSHrefValue(eventTitle, eventDescription, eventLocation, eventStartDate, eventEndDate, isAllDayEvent);
      return "<a class=\"mppw-ics-link\" href=\"".concat(icsLink, "\">Add to Calendar ></a>");
    }
  }, {
    key: "GetICSHrefValue",
    value: function GetICSHrefValue(eventTitle, eventDescription, eventLocation, eventStartDate, eventEndDate) {
      var isAllDayEvent = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      // iOS requires a specific format or does not work
      var startDateFormatted = !!eventStartDate ? eventStartDate.replaceAll('-', '').replaceAll(':', '') + "Z" : "";
      var endDateFormatted = !!eventEndDate ? eventEndDate.replaceAll('-', '').replaceAll(':', '') + "Z" : "";
      var newLineEncodingChar = "%0A"; // Create ics data link

      var icsSummary = "SUMMARY:".concat(encodeURIComponent(eventTitle)).concat(newLineEncodingChar);
      var icsDescription = "DESCRIPTION:".concat(encodeURIComponent(eventDescription)).concat(newLineEncodingChar);
      var icsLocation = "LOCATION:".concat(encodeURIComponent(eventLocation)).concat(newLineEncodingChar);
      var icsEndDate = "";
      var icsStartDate = "";

      if (isAllDayEvent === true) {
        icsStartDate = "DTSTART;VALUE=DATE:".concat(startDateFormatted.split("T")[0]).concat(newLineEncodingChar);
      } else {
        icsStartDate = "DTSTART:".concat(startDateFormatted).concat(newLineEncodingChar);
        icsEndDate = "DTEND:".concat(endDateFormatted).concat(newLineEncodingChar);
      }

      var icsContent = "".concat(icsStartDate).concat(icsEndDate).concat(icsSummary).concat(icsDescription).concat(icsLocation);
      var icsLink = "data:text/calendar;charset=utf8,BEGIN:VCALENDAR".concat(newLineEncodingChar, "VERSION:2.0").concat(newLineEncodingChar, "BEGIN:VEVENT").concat(newLineEncodingChar).concat(icsContent, "END:VEVENT").concat(newLineEncodingChar, "END:VCALENDAR").concat(newLineEncodingChar);
      return icsLink;
    }
  }]);

  return ICSCalendarBuilder;
}();